<template>
  <div :class="['web-004-page', isMobile && 'mobile-page']">
    <carousel
      v-if="cp_carouselImages.length"
      :list="cp_carouselImages"
    />
    <div class="static-resources sr1">
      <div
        v-if="!isMobile"
        class="content vertical"
      >
        <div class="title">
          什么是优学派AI督学智习室系统
        </div>
        <div class="detail">
          <span class="prominent">优学派AI督学智习系统</span>
          <span>，是专门为线下机构与学校量身打造的 AI 辅助督学工具。该系统主要涵盖管理端、督学端、学生端以及家长端四个部分。借助这四个端口的协同运作，此系统能够有效解决诸多教育难题：一方面，传统督学模式存在成本高昂的问题，管理效率与服务质量难以保障，传统教育机构转型也面临重重困难；另一方面，职工家长由于工作繁忙，自身知识面受限，且可能遗忘所学知识，无法为孩子提供有效的学习辅导，导致孩子学习无人监管。</span>
        </div>
        <img
          src="~@/assets/web004/AISuperviseSystem/pic1.png"
        >
      </div>
      <img
        v-else
        src="~@/assets/web004/AISuperviseSystem/m-pic1.png"
        style="width: 100%"
      >
    </div>
    <div
      class="static-resources sr2"
      :style="{height: isMobile ? mobileBgHeight + 'px' : '700px'}"
    >
      <div class="content horizontal">
        <img
          v-if="!isMobile"
          src="~@/assets/web004/AISuperviseSystem/pic2.png"
        >
        <img
          v-else
          src="~@/assets/web004/AISuperviseSystem/m-pic2.png"
          style="width: 45%"
        >
        <div>
          <div class="title">
            学生端功能介绍
          </div>
          <div class="detail">
            <span>学生端，优学派研发团队定制开发“智慧教育平台”作为学生学习和练习端口。<br>
              根据学生定级测结果，结合系统的智能分析自动生成孩子专属的学习计划。督学师也可根据学员的任务目标完成情况，进行人工调整任务安排。帮助孩子查漏补缺的同时，提升学习效率和学习自信。</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="static-resources sr3"
      :style="{height: isMobile ? mobileBgHeight + 'px' : '700px'}"
    >
      <div class="content horizontal">
        <div>
          <div class="title">
            督学端功能介绍
          </div>
          <div class="detail">
            <span>督学师作为AI督学系统中的重要角色，在孩子的学习过程中，督学师除了可以通过督学后台，实时查看孩子正在做的题和学习状态。还可以通过报告来安排适合孩子的学习任务，从而根据每个孩子不同的学习能力，制定安排适合的学习目标和内容,帮助孩子夯实基础，专项突破，高效提分。并对异常情况进行干预，帮助孩子专注学习和坚持学习，并养成良好的学习习惯。</span>
          </div>
        </div>
        <img
          v-if="!isMobile"
          src="~@/assets/web004/AISuperviseSystem/pic3.png"
        >
        <img
          v-else
          src="~@/assets/web004/AISuperviseSystem/m-pic3.png"
          style="width: 40%"
        >
      </div>
    </div>
    <div
      class="static-resources sr2"
      :style="{height: isMobile ? mobileBgHeight + 'px' : '700px'}"
    >
      <div class="content horizontal">
        <img
          v-if="!isMobile"
          src="~@/assets/web004/AISuperviseSystem/pic4.png"
        >
        <img
          v-else
          src="~@/assets/web004/AISuperviseSystem/m-pic4.png"
          style="width: 35%"
        >
        <div>
          <div class="title">
            管理端功能介绍
          </div>
          <div class="detail">
            <span>管理端，作为机构管理端口，满足样机学员和购机学员两类学员学习需求。<br>
              帮助机构轻松做好门店、督学师、学员的管理工作。<br>
              通过学员管理，快速建立学员档案、一键配置学习时段，配置成功后学生端和家长端便会收到开课提醒。学员一键签到，同时系统会自动记录课时情况，课时完成后，自动消课，通过系统查看每个孩子的到课情况。管理全程自动化，学员再多也不怕。</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="static-resources sr4"
      :style="{height: isMobile ? mobileBgHeight + 'px' : '700px'}"
    >
      <div class="content horizontal">
        <div>
          <div class="title">
            家长端功能介绍
          </div>
          <div class="detail">
            <span>家长端，作为家长协同督学端口<br>
              提供孩子每日的学习进度和学习报告，系统及时传送给家长，方便家长在工作之余查看孩子的学习情况。做到快速有效的互动沟通，让家长全面地了解孩子的学习情况</span>
          </div>
        </div>
        <img
          v-if="!isMobile"
          src="~@/assets/web004/AISuperviseSystem/pic5.png"
        >
        <img
          v-else
          src="~@/assets/web004/AISuperviseSystem/m-pic5.png"
          style="width: 20%"
        >
      </div>
    </div>
    <contentList v-if="!isMobile" />
    <contentList_mobile v-else />
  </div>
</template>

<script>

import api from '../../../proxy';
import carousel from '../../components/carousel.vue';
import contentList from '../../components/contentList.vue';
import contentList_mobile from '../../components/contentList_mobile.vue';
export default {
    name: 'AISuperviseSystem',
    components: {
        carousel, contentList, contentList_mobile,
    },
    data () {
        return {
            carouselImages: [],
            mobileBgHeight: 400,
        };
    },
    computed: {
        flatTreeList () {
            return this.$store.getters['system/getFlatTreeList'];
        },
        isMobile () {
            return (/Mobi|Android|iPhone/i.test(navigator.userAgent));
        },
        cp_carouselImages () {
            if (!this.isMobile) {
                return this.carouselImages.filter(itm => itm.status === 1 && [0, 1].includes(itm.clientType));
            }
            return this.carouselImages.filter(itm => itm.status === 1 && [0, 2].includes(itm.clientType));
        },
    },
    watch: {
        async flatTreeList (val) {
            this.getCarouselImages();
        },
    },
    mounted () {
        this.mobileBgHeight = 740 * (document.body.offsetWidth / 1200);
        this.getCarouselImages();
    },
    methods: {
        async getCarouselImages () {
            if (this.flatTreeList.length) {
                const { catalogId, siteId } = this.$route.query;
                const item = this.flatTreeList.find(itm => +itm.catalogId === +catalogId);
                if (!item || item.rotation === 0) return;
                const res = item.rotation === 1 ? await api.getRotationList({ siteId, pageNo: 1, pageSize: 999 }) : await api.getCatalogRotationList({ catalogId });
                if (res.errcode === 0) {
                    this.carouselImages = res.data.list || res.data;
                } else {
                    this.$message.error(res.errmsg);
                }
            }
        },
    },
};
</script>

<style scoped lang="scss">
.web-004-page {
    width: 100%;
    min-height: calc(100vh - 200px);
    .static-resources {
        width: 100%;
        display: block;
        box-sizing: border-box;
        .content {
            width: 1200px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            align-items: center;
            &.vertical {
                flex-direction: column;
            }
            .title {
                font-weight: 600;
                color: #141414;
            }
            .detail {
                width: 100%;
                line-height: 36px;
            }
            .prominent {
                color: #1252FF;
                font-weight: 600;
            }
        }
        span {
            font-weight: 400;
            font-size: 16px;
            color: #676769;
        }
        &.sr1 {
           height: 840px;
            background-image: url("~@/assets/web004/AISuperviseSystem/bg1.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .title {
                text-align: center;
                padding-top: 60px;
                padding-bottom: 40px;
                font-size: 38px;
                line-height: 56px;
            }
            .detail {
                margin-bottom: 60px;
            }
        }
        &.sr2 {
           height: 700px;
            background-image: url("~@/assets/web004/AISuperviseSystem/bg2.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .title {
                margin-left: 140px;
                padding-bottom: 30px;
                font-size: 34px;
                color: #141414;
                line-height: 50px;
            }
            .detail {
                width: 480px;
                margin-left: 140px;
                position: relative;
                &::before {
                    content: '';
                    width: 16px;
                    height: 16px;
                    background-image: url("~@/assets/web004/AISuperviseSystem/circle.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    position: absolute;
                    left: -36px;
                    top: 8px;
                }
            }
        }
        &.sr3, &.sr4{
            height: 700px;
            background-image: url("~@/assets/web004/AISuperviseSystem/bg3.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .title {
                padding-bottom: 30px;
                font-size: 34px;
                color: #141414;
                line-height: 50px;
            }
            .detail {
                width: 480px;
                margin-left: 0;
                margin-right: 66px;
                position: relative;
                &::before {
                    content: '';
                    width: 16px;
                    height: 16px;
                    background-image: url("~@/assets/web004/AISuperviseSystem/circle.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    position: absolute;
                    left: -36px;
                    top: 9px;
                }
            }
        }
        &.sr4 {
            .detail {
                margin-right: 300px;
            }
        }
    }
    &.mobile-page {
        min-height: calc(100vh - 160px);
        .static-resources {
            width: 100%;
            .content {
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                overflow: hidden;
                .title {
                    font-size: 14px;
                    margin-left: 20px;
                    line-height: 40px;
                    padding-bottom: 0;
                }
                .detail {
                    font-size: 12px;
                    margin-left: 20px;
                    line-height: 16px;
                    width: calc(100% - 20px);
                    span {
                        font-size: 10px;
                    }
                    &:before {
                        content: '';
                        width: 10px;
                        height: 10px;
                        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAVxJREFUOE+dk09LAmEQxn+zkp6Egs71ATawc8fCi3Tec4cgAoXIL+AXMAUFIQqELrEUgZQEZV2ic4F+gDxHgZ403Il1V9NFQ31v887MM8/8eYTAe3tSU5V9EeLAmutWaKI8iHC2uS2N0RQZGHVbw50Vso5yCIQmBkFPhFLkm/SGJV03pg9g2xpej1JV2AkymmQL1D7aJCxLun2A11stKCRdrrM+EYpbu5KSl4qajsN7kPZ/QH6dXsggJs/XmgOOZq0ciMvLo611Vcwxx3C0U2B9CiI05P5SWzhEF2Jg0Ja7C23BggDQlkpZ6zDegga2IdNbasjNueZU/SEOAqcADL//ZpCXq1M1FX+Nc9wBQk8g5l1iSQuOkpxnkEaIonUgKQ8go+GfVarobKeMUFv6JGFl/FMegHSWySojYgq25NI2KEW+SLvJQzGNUi+feHIG4qgnZ4QmeHLeOx6X8y/y8HztaPQFygAAAABJRU5ErkJggg==);
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        position: absolute;
                        left: -14px;
                        top: 3px;
                    }
                }
            }
            &.sr1 {
                background-image: url("~@/assets/web004/AISuperviseSystem/m-pic1.png");
                height: auto;
            }
            &.sr2 {
                position: relative;
                width: 100%;
                background-image: url("~@/assets/web004/AISuperviseSystem/m-bg3.png");
                padding: 0 16px;
                .detail {
                    width: calc(100% - 20px);
                }
            }
            &.sr3 {
                position: relative;
                width: 100%;
                background-image: url("~@/assets/web004/AISuperviseSystem/m-bg2.png");
                padding: 0 16px;
                .title {
                    margin-left: 14px;
                    margin-right: 20px;
                }
                .detail {
                    margin-left: 14px;
                    margin-right: 20px;
                    width: calc(100% - 24px);
                }
            }
            &.sr4 {
                position: relative;
                width: 100%;
                background-image: url("~@/assets/web004/AISuperviseSystem/m-bg2.png");
                padding: 0 16px;
                .content {
                    width: calc(100% - 20px);
                    margin: 0;
                }
                .title {
                    margin-left: 14px;
                    margin-right: 30px;
                }
                .detail {
                    margin-left: 14px;
                    margin-right: 30px;
                    width: calc(100% - 40px);
                }
            }
        }
    }
}
</style>
